import { z } from 'zod/v4';

import { integrationTypeSchema } from './integration-type.schema';

export const partnerSettingsSchema = z.object({
  accountPartnerId: z.number(),
  partnerId: z.string().nullable(),
  externalIdType: z.number().nullable(),
  integrationType: integrationTypeSchema,
  enabled: z.boolean(),
  enableAssetReplication: z.boolean(),
  enableAmsDiagnostics: z.boolean(),
});

export type PartnerSettings = z.infer<typeof partnerSettingsSchema>;
